const menuClasses = {
    icon: "flux-menu-icon",
    rightArrow: "flux-menu-right-arrow",
    icons90Deg: "flux-menu-icon-90-degrees",
    icons270Deg: "flux-menu-icon-270-degrees",
    menuItem: "flux-menu-item",
    menuItemWithShortcut: "flux-menu-item-with-shortcut",
    rightLabel: "flux-menu-right-label",
    rightLabelSpacer: "flux-menu-right-label-spacer",
    containsChip: "flux-menu-item-contains-chip",
} as const;

export default menuClasses;
